import { metrics } from '@seek/metrics-js';
import React from 'react';

import { errorLogging } from '../../errorLogging';
import { AlertPanel } from '../AlertPanel/AlertPanel';

interface ErrorBoundaryProps {
  questionnaireId: string;
  helpInformation?: React.ReactNode;
  children?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error | null, info: Record<string, any>): void {
    metrics.count('error-shown');
    errorLogging().withScope((scope) => {
      Object.keys(info).forEach((key) => {
        scope.setExtra(key, info[key]);
      });
      if (this.props.questionnaireId) {
        scope.setExtra('questionnaireId', this.props.questionnaireId);
      }
      errorLogging().captureException(error);
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <AlertPanel>{this.props.helpInformation}</AlertPanel>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
